<script>
import Datatable from "@/router/layouts/table-datatable.vue";
// import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import ModalJadwalTimer from "./modal-edit-jadwal-timer.vue";

/**
 * Dashboard Component
 */
export default {
  props: ["status_jadwal"],
  components: {
    Datatable,
    // Pagination,
    ModalJadwalTimer,
    // ModalImportKompetensi,
  },
  data() {
    // definisi kolom yang dipakai
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        width: "auto",
        label: "Nama Level",
        name: "-",
      },
      {
        width: "auto",
        label: "Timer",
        name: "-",
      },
      {
        width: "auto",
        label: "Output Soal PG",
        name: "-",
      },
      {
        width: "auto",
        label: "Output Soal BS",
        name: "-",
      },
      {
        width: "auto",
        label: "Output Soal MJ",
        name: "-",
      },
      {
        width: "auto",
        label: "Output Soal PG SK",
        name: "-",
      },
      {
        width: "auto",
        label: "Output Soal BS SK",
        name: "-",
      },
      {
        width: "auto",
        label: "Output Soal Esai",
        name: "-",
      },
      {
        width: "auto",
        label: "Aksi",
        name: "-",
      },
    ];

    return {
      title: "Jadwal Pelaksanaan",
      showModalEditTimer: false,
      selected_row: {},
      selected_level: "",
      loadingTable: true,
      table_data: [],
      columns: columns,
    };
  },
  mounted() {
    let self = this;
    self.getDataTable();
  },
  methods: {
    fullDateTimeFormat(datetime) {
      return moment(datetime).format("YYYY-MM-DD HH:mm");
    },
    getDataTable(
      url = process.env.VUE_APP_BACKEND_URL_VERSION +
        `master/jadwal-pelaksanaan/${this.$route.params.id}/setup-jadwal/jadwal-timer`
    ) {
      let self = this;
      self.loadingTable = true;

      var config = {
        method: "get",
        url: url,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          if (response_data.meta.code == 200) {
            self.table_data = response_data.data;
          } else {
            Swal.fire({
              icon: "error",
              title: "Gagal",
              text: response_data.meta.message,
            });
          }
          self.loadingTable = false;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    editJadwalTimer(item) {
      this.showModalEditTimer = true;
      this.selected_row = {};
      this.selected_row = { ...item };
      this.selected_level = this.selected_row.level_idlevel;
    },
    reset(row) {
      Swal.fire({
        title: "Konfirmasi",
        text: `Apakah Anda yakin ingin mereset timer dan jumlah soal untuk level ${row.level.nama_level}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Iya",
        cancelButtonText: "Tidak",
      }).then((result) => {
        if (result.isConfirmed) {
          if (!row.idjadwal_timer) {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
            });
            return;
          }

          this.loadingTable = true;
          axios({
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `master/jadwal-pelaksanaan/${this.$route.params.id}/setup-jadwal/jadwal-timer/${row.idjadwal_timer}`,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          })
            .then((response) => {
              let response_data = response.data;
              if (response_data.meta.code == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: response_data.meta.message,
                });
                this.getDataTable();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Gagal",
                  text: response_data.meta.message,
                });
              }
            })
            .catch((errors) => {
              console.log(errors);
            })
            .finally(() => {
              this.loadingTable = false;
            });
        }
      });
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="card-title">Konfigurasi Timer dan Jumlah Soal</div>
            </div>
            <datatable :columns="columns">
              <tbody>
                <tr v-if="loadingTable">
                  <td colspan="10" class="text-center">
                    <i class="fas fa-spinner fa-spin"></i> Loading...
                  </td>
                </tr>
                <tr v-else-if="table_data == ''">
                  <td class="text-center" colspan="10">Data Tidak Tersedia</td>
                </tr>
                <tr
                  v-else
                  v-for="(row_data, key_data) in table_data"
                  :key="key_data"
                >
                  <td class="text-center">
                    {{ key_data + 1 }}
                  </td>
                  <td>
                    {{ row_data.level.nama_level }}
                  </td>
                  <td>
                    {{ row_data.timer ?? "0" }}
                  </td>
                  <td>
                    {{ row_data.output_soal_pg ?? "0" }}
                  </td>
                  <td>
                    {{ row_data.output_soal_bs ?? "0" }}
                  </td>
                  <td>
                    {{ row_data.output_soal_mj ?? "0" }}
                  </td>
                  <td>
                    {{ row_data.output_soal_pgsk ?? "0" }}
                  </td>
                  <td>
                    {{ row_data.output_soal_bssk ?? "0" }}
                  </td>
                  <td>
                    {{ row_data.output_soal_text ?? "0" }}
                  </td>
                  <td>
                    <div class="btn-group btn-group-sm">
                      <button
                        v-if="status_jadwal != 2"
                        type="button"
                        class="btn btn-warning btn-sm"
                        v-on:click="editJadwalTimer(row_data)"
                      >
                        <i class="fa fa-edit"></i> Edit
                      </button>
                      <button
                        v-if="status_jadwal != 2"
                        type="button"
                        class="btn btn-danger btn-sm"
                        v-on:click="reset(row_data)"
                      >
                        <i class="fa fa-undo"></i> Reset
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </datatable>
          </div>
        </div>
      </div>
    </div>
  </div>
  <b-modal
    v-model="showModalEditTimer"
    hide-footer
    :title="
      `Edit Timer dan Jumlah Soal Level ` + selected_row?.level?.nama_level
    "
  >
    <ModalJadwalTimer
      :selectedData="selected_row"
      :level="selected_level"
      @submitForm="
        showModalEditTimer = false;
        getDataTable();
      "
      v-if="showModalEditTimer"
    />
  </b-modal>
</template>
